import {DocumentRow} from "../types/documents-modal-row.types";
import {DocumentBtnKey, DocumentRowKey} from "../types/document-modal.types";
import {FilesStatus} from "../../../../types/files-status.types";
import {defaultFilesStatus} from "../../../../models/default-file-params";

export function isDocumentRowKey(key: string): key is DocumentRowKey {
  return ['contract', 'erid', 'payment', 'act', 'edo', 'oneC'].includes(key);
}

export function isDocumentBtnKey(key: string): key is DocumentBtnKey {
  return ['bankDetails', 'contract', 'erid', 'payment', 'act', 'edo', 'oneC'].includes(key);
}

export const bankDetailsFields: DocumentRow = {
  title: 'Реквизиты',
  key: 'bankDetails',
  isModalByKey: true,
  rowFields: [
    {
      fieldName: 'completeDate',
      label: 'Дата заполнения',
      type: 'text'
    }
  ]
}

export const contractFields: DocumentRow = {
  title: 'Договор',
  key: 'contract',
  rowFields: [
    {
      fieldName: 'number',
      label: 'Номер договора',
      type: 'text'
    },
    {
      fieldName: 'date',
      label: 'Дата',
      type: 'date'
    },
    {
      fieldName: 'status',
      label: 'Статус и дней статуса',
      type: 'select'
    },
    {
      fieldName: 'processedByName',
      label: 'Кто оформляет',
      type: 'text'
    },
    {
      fieldName: 'signedDocumentLink',
      label: 'Подписанный договор',
      type: 'text',
      isLink: true,
      fieldLinkName: 'contract.signedDocumentLink'
    },
    {
      fieldName: 'generate',
      label: 'Сгенерировать',
      type: 'button',
      isIconStatus: true,
      statusBtnName: 'generatingStatus'
    },
    {
      fieldName: 'signed',
      label: 'Подписанные',
      type: 'button',
      isIconStatus: true,
      statusBtnName: 'uploadingStatus'
    }
  ],
}

export const eridFields: DocumentRow = {
  title: 'Ерид',
  key: 'erid',
  rowFields: [
    {
      fieldName: 'status',
      label: 'Статус',
      type: 'select'
    },
    {
      fieldName: 'number',
      label: 'Маркер в ОРД (ТОКЕН)',
      type: 'text'
    }
  ]
}

export const paymentFields: DocumentRow = {
  title: 'Оплата',
  key: 'payment',
  rowFields: [
    {
      fieldName: 'status',
      label: 'Статус',
      type: 'select'
    },
    {
      fieldName: 'date',
      label: 'Дата',
      type: 'date'
    },
    {
      fieldName: 'link',
      label: 'Документ оплаты',
      type: 'text',
      isLink: true,
      fieldLinkName: 'payment.link'
    }
  ]
}

export const actFields: DocumentRow = {
  title: 'Акт',
  key: 'act',
  rowFields: [
    {
      fieldName: 'status',
      label: 'Статус',
      type: 'select'
    },
    {
      fieldName: 'date',
      label: 'Дата',
      type: 'date'
    },
    {
      fieldName: 'actLink',
      label: 'Акт в ОРД',
      type: 'text',
      isLink: true,
      fieldLinkName: 'act.actLink'
    },
    {
      fieldName: 'receiptLink',
      label: 'Ссылка на чек',
      type: 'text',
      isLink: true,
      fieldLinkName: 'act.receiptLink'
    }
  ]
}

export const edoFields: DocumentRow = {
  title: 'ЭДО',
  key: 'edo',
  rowFields: [
    {
      fieldName: 'status',
      label: 'Статус',
      type: 'select'
    }
  ]
}

export const oneCFields: DocumentRow = {
  title: '1С',
  key: 'oneC',
  rowFields: [
    {
      fieldName: 'status',
      label: 'Статус',
      type: 'select'
    },
    {
      fieldName: 'documentDiskLink',
      label: 'Диск документов',
      type: 'text',
      isLink: true,
      fieldLinkName: 'oneC.documentDiskLink'
    }
  ]
}

export const defaultDocumentsFilesStatus: FilesStatus = {
  ...defaultFilesStatus,
  generatingStatus: 'ERROR',
  uploadingStatus: 'ERROR'

}
